<div class="dni-section bg-white rounded-lg shadow-md border border-gray-200 p-6 mb-6">
  <!-- Header con titulo y estado -->
  <div class="flex items-center justify-between mb-6">
    <h3 class="text-xl font-semibold text-gray-900 flex items-center gap-2">
      <svg class="w-6 h-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2" />
      </svg>
      DNI / NIE
    </h3>
    
    <!-- Estado del DNI -->
    <div class="flex items-center gap-2">
      <span [class]="'inline-block px-3 py-1 rounded-full text-sm font-medium ' + getStatusColor()">
        {{ getStatusText() }}
      </span>
      <span *ngIf="getDaysUntilExpiration() !== null" class="text-xs text-gray-500">
        <ng-container *ngIf="getDaysUntilExpiration()! > 0">({{ getDaysUntilExpiration() }}d)</ng-container>
        <ng-container *ngIf="getDaysUntilExpiration()! < 0">(hace {{ -getDaysUntilExpiration()! }}d)</ng-container>
        <ng-container *ngIf="getDaysUntilExpiration()! === 0">(hoy)</ng-container>
      </span>
    </div>
  </div>

  <!-- Fila superior: Informacion del DNI -->
  <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
    <!-- Numero de DNI -->
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">
        Numero de DNI/NIE
      </label>
      <input
        type="text"
        [value]="user?.nif || 'No especificado'"
        disabled
        class="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-gray-700"
      />
    </div>

    <!-- Fecha de Expiracion -->
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-1">
        Fecha de Expiracion <span class="text-red-500">*</span>
      </label>
      <input
        type="date"
        [(ngModel)]="dniExpirationDate"
        [placeholder]="dniExpirationDate || 'Seleccione una fecha'"
        class="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      />
    </div>

    <!-- Boton Guardar -->
    <div class="flex items-end">
      <button
        (click)="saveDniExpiration()"
        [disabled]="savingDate"
        class="w-full bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 flex items-center justify-center gap-2 text-sm h-[42px]">
        <svg *ngIf="savingDate" class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        {{ savingDate ? 'Guardando...' : 'Guardar Fecha' }}
      </button>
    </div>
  </div>

  <!-- Fila inferior: Imagenes del DNI -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <!-- DNI Parte Delantera -->
    <div class="border border-gray-200 rounded-lg p-4 bg-gray-50">
      <label class="block text-sm font-medium text-gray-700 mb-3">
        Parte Delantera
      </label>

      <!-- Preview de imagen delantera -->
      <div *ngIf="dniFrontImage && !isFrontPdf()" class="border border-gray-300 rounded-md overflow-hidden bg-white mb-3">
        <img
          [src]="getDniFrontImageUrl()"
          alt="DNI Delantero"
          class="w-full h-auto max-h-48 object-contain"
        />
      </div>

      <!-- Preview de PDF delantera -->
      <div *ngIf="dniFrontImage && isFrontPdf()" class="border border-gray-300 rounded-md p-4 bg-white flex flex-col items-center justify-center mb-3">
        <svg class="w-12 h-12 text-red-500 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
        </svg>
        <span class="text-xs text-gray-600">{{ dniFrontImage.file_name }}</span>
        <a [href]="getDniFrontImageUrl()" target="_blank" class="text-blue-600 hover:underline text-xs mt-1">Ver PDF</a>
      </div>

      <!-- Sin imagen delantera -->
      <div *ngIf="!dniFrontImage" class="border-2 border-dashed border-gray-300 rounded-md p-6 text-center bg-white mb-3">
        <svg class="mx-auto h-10 w-10 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
        </svg>
        <p class="mt-2 text-sm text-gray-500">Sin imagen</p>
      </div>

      <!-- Boton Subir Delantera -->
      <label
        class="block w-full text-center bg-gray-200 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-300 cursor-pointer transition-colors duration-200 text-sm"
        [class.opacity-50]="loadingFront"
        [class.cursor-not-allowed]="loadingFront">
        <span *ngIf="!loadingFront">{{ dniFrontImage ? 'Cambiar' : 'Subir' }}</span>
        <span *ngIf="loadingFront" class="flex items-center justify-center gap-2">
          <svg class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Subiendo...
        </span>
        <input
          type="file"
          accept="image/*,application/pdf"
          (change)="onFrontFileSelected($event)"
          [disabled]="loadingFront"
          class="hidden"
        />
      </label>
    </div>

    <!-- DNI Parte Trasera -->
    <div class="border border-gray-200 rounded-lg p-4 bg-gray-50">
      <label class="block text-sm font-medium text-gray-700 mb-3">
        Parte Trasera
      </label>

      <!-- Preview de imagen trasera -->
      <div *ngIf="dniBackImage && !isBackPdf()" class="border border-gray-300 rounded-md overflow-hidden bg-white mb-3">
        <img
          [src]="getDniBackImageUrl()"
          alt="DNI Trasero"
          class="w-full h-auto max-h-48 object-contain"
        />
      </div>

      <!-- Preview de PDF trasera -->
      <div *ngIf="dniBackImage && isBackPdf()" class="border border-gray-300 rounded-md p-4 bg-white flex flex-col items-center justify-center mb-3">
        <svg class="w-12 h-12 text-red-500 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
        </svg>
        <span class="text-xs text-gray-600">{{ dniBackImage.file_name }}</span>
        <a [href]="getDniBackImageUrl()" target="_blank" class="text-blue-600 hover:underline text-xs mt-1">Ver PDF</a>
      </div>

      <!-- Sin imagen trasera -->
      <div *ngIf="!dniBackImage" class="border-2 border-dashed border-gray-300 rounded-md p-6 text-center bg-white mb-3">
        <svg class="mx-auto h-10 w-10 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
        </svg>
        <p class="mt-2 text-sm text-gray-500">Sin imagen</p>
      </div>

      <!-- Boton Subir Trasera -->
      <label
        class="block w-full text-center bg-gray-200 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-300 cursor-pointer transition-colors duration-200 text-sm"
        [class.opacity-50]="loadingBack"
        [class.cursor-not-allowed]="loadingBack">
        <span *ngIf="!loadingBack">{{ dniBackImage ? 'Cambiar' : 'Subir' }}</span>
        <span *ngIf="loadingBack" class="flex items-center justify-center gap-2">
          <svg class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Subiendo...
        </span>
        <input
          type="file"
          accept="image/*,application/pdf"
          (change)="onBackFileSelected($event)"
          [disabled]="loadingBack"
          class="hidden"
        />
      </label>
    </div>
  </div>

  <p class="text-xs text-gray-500 text-center mt-4">
    Formatos permitidos: JPG, PNG, PDF. Maximo 10MB por archivo.
  </p>
</div>
